var map = {
	"./ss0.png": 194,
	"./ss0_en.png": 195,
	"./ss0_zh.png": 196,
	"./ss1.jpg": 107,
	"./ss10.jpg": 115,
	"./ss11.jpg": 116,
	"./ss2.jpg": 108,
	"./ss3.jpg": 109,
	"./ss4.jpg": 110,
	"./ss5.jpg": 111,
	"./ss6.jpg": 112,
	"./ss7.jpg": 113,
	"./ss9.jpg": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 588;